<h3  mat-dialog-title >Submit to AIS?</h3>

<div mat-dialog-actions>
    <button mat-raised-button mat-button color="primary" [mat-dialog-close]="data" (click)="confirm()">Confirm</button>  
    <button mat-raised-button mat-button color="primary" (click)="onNoClick()">Cancel</button>
</div>
